import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ParticipantInfo {
  pId: any;
  type: string;
  participantType: string;
  participantName: string;
  locationId: string;
  emailId: string;
  phone: string;
  phoneExt: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  state: string;
  zipCode: string;
  pContactId: number;
  version: number;
  nsCustomerId: string;
  nsLocationId: string;
  nsLocationNameId: string;
  nsDepartmentId: string;
  status: string;
  searchParticipantName: string;
  rowsPerPage: number;
  page: number;
  partcipantArray: any[];
  logo: any;
  checkedFlag: boolean;
  selectedLogo: any[];
}

const initialState: ParticipantInfo = {
  pId: "",
  type: "DnL",
  participantType: "",
  participantName: "",
  locationId: "",
  emailId: "",
  phone: "",
  phoneExt: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  county: "",
  state: "",
  zipCode: "",
  pContactId: 0,
  version: 0,
  nsCustomerId: "",
  nsLocationId: "",
  nsDepartmentId: "",
  nsLocationNameId: "",
  status: "Active",
  searchParticipantName: "",
  rowsPerPage: 5,
  page: 0,
  partcipantArray: [],
  logo:"",
  checkedFlag:false,
  selectedLogo: [],
};

const createParticipantSlice = createSlice({
  name: "createParticipant",
  initialState,
  reducers: {
    setCreateParticipant: (
      state,
      action: PayloadAction<Partial<ParticipantInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeCreateParticipant: () => initialState,
  },
});

export const { setCreateParticipant, removeCreateParticipant } =
  createParticipantSlice.actions;
export default createParticipantSlice.reducer;
